var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCouponArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.36602 14.5C8.98112 15.1667 8.01887 15.1667 7.63397 14.5L0.272758 1.75C-0.112141 1.08334 0.368982 0.25 1.13878 0.25L15.8612 0.250002C16.631 0.250002 17.1121 1.08333 16.7272 1.75L9.36602 14.5Z",
    fill: "#979797"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCouponArrow);
export default __webpack_public_path__ + "static/media/couponArrow.c5978a47317ac8380e6b0b0dc48630c2.svg";
export { ForwardRef as ReactComponent };